import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setUseListSizeAction } from "@oldDashboard/legacyActions/dashboardClient";

interface useListOverTimeProps { affiliateSelected: String, launchSelected: String, timePeriodSelected: String, searching: boolean }

const useListSize = (props: useListOverTimeProps) => {
    const { affiliateSelected, launchSelected, timePeriodSelected, searching } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchListSize();
    }, [searching, launchSelected]);

    const fetchListSize = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getListSize(affiliateSelected, launchSelected, timePeriodSelected);
            if(response.success){
                if(response.chart_data.data.currently_served)
                    setUseListSizeAction(response.chart_data.data.currently_served);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
     
    }
    return {isLoading, fetchListSize}
}

export default useListSize